@if (open() && currentStep(); as step) {
<div
  class="tour-overlay"
  role="dialog"
  aria-modal="true"
  aria-label="Editor onboarding tour"
>
  <!-- Dark backdrop with a spotlight cut-out around the current anchor.
       We render four rectangles (top / bottom / left / right of the anchor)
       so the anchor sits in a clear "hole" without needing CSS mask. -->
  @if (spotlightRect(); as r) {
  <div
    class="tour-spotlight"
    [style.top.px]="r.top"
    [style.left.px]="r.left"
    [style.width.px]="r.width"
    [style.height.px]="r.height"
    aria-hidden="true"
  ></div>
  <div
    class="tour-backdrop tour-backdrop--top"
    [style.height.px]="r.top"
    aria-hidden="true"
  ></div>
  <div
    class="tour-backdrop tour-backdrop--bottom"
    [style.top.px]="r.top + r.height"
    aria-hidden="true"
  ></div>
  <div
    class="tour-backdrop tour-backdrop--left"
    [style.top.px]="r.top"
    [style.height.px]="r.height"
    [style.width.px]="r.left"
    aria-hidden="true"
  ></div>
  <div
    class="tour-backdrop tour-backdrop--right"
    [style.top.px]="r.top"
    [style.height.px]="r.height"
    [style.left.px]="r.left + r.width"
    aria-hidden="true"
  ></div>
  } @else {
  <!-- Anchor missing — fall back to a full overlay so the tooltip still
       has visual contrast. -->
  <div class="tour-backdrop tour-backdrop--full" aria-hidden="true"></div>
  }

  <!-- Tooltip card -->
  @if (tooltipPos(); as pos) {
  <div
    class="tour-tooltip"
    [style.top.px]="pos.top"
    [style.left.px]="pos.left"
  >
    <div class="tour-tooltip__counter">
      Step {{ stepIndex() + 1 }} of {{ stepCount }}
    </div>
    <h3 class="tour-tooltip__title">{{ step.title }}</h3>
    <p class="tour-tooltip__body">{{ step.body }}</p>
    <div class="tour-tooltip__actions">
      <button
        type="button"
        class="tour-tooltip__skip"
        (click)="skip()"
      >
        Skip tour
      </button>
      <div class="tour-tooltip__nav">
        @if (!isFirst()) {
        <button
          type="button"
          class="tour-tooltip__btn tour-tooltip__btn--ghost"
          (click)="prev()"
        >
          Back
        </button>
        }
        <button
          type="button"
          class="tour-tooltip__btn tour-tooltip__btn--primary"
          (click)="next()"
          autofocus
        >
          @if (isLast()) { Got it } @else { Next → }
        </button>
      </div>
    </div>
  </div>
  } @else {
  <!-- Tooltip with no anchor — centre it for graceful degradation. -->
  <div class="tour-tooltip tour-tooltip--centered">
    <div class="tour-tooltip__counter">
      Step {{ stepIndex() + 1 }} of {{ stepCount }}
    </div>
    <h3 class="tour-tooltip__title">{{ step.title }}</h3>
    <p class="tour-tooltip__body">{{ step.body }}</p>
    <div class="tour-tooltip__actions">
      <button type="button" class="tour-tooltip__skip" (click)="skip()">
        Skip tour
      </button>
      <button
        type="button"
        class="tour-tooltip__btn tour-tooltip__btn--primary"
        (click)="next()"
      >
        @if (isLast()) { Got it } @else { Next → }
      </button>
    </div>
  </div>
  }
</div>
}
